import { render, staticRenderFns } from "./WarningIndicator.vue?vue&type=template&id=ed9521a8&scoped=true"
import script from "./WarningIndicator.vue?vue&type=script&lang=js"
export * from "./WarningIndicator.vue?vue&type=script&lang=js"
import style0 from "./WarningIndicator.vue?vue&type=style&index=0&id=ed9521a8&prod&lang=sass"
import style1 from "./WarningIndicator.vue?vue&type=style&index=1&id=ed9521a8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9521a8",
  null
  
)

export default component.exports